import React, { useCallback, useEffect, useState } from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

import SORT_ICON from "../images/Icon=Sort.svg";

export default function CategoryMenu({ onFetchLatestPets }) {
	const [categories, setCategories] = useState([]);
	const [selectedCategories, setSelectedCategories] = useState([]);
	const [isOpen, setOpen] = useState(false);

	const onHandleCategoryMenu = useCallback(
		(isUpdate) => {
			setOpen(false);
			if (!isUpdate) {
				const selectedCategories = localStorage.getItem("category-option") || "[]";
				setSelectedCategories(JSON.parse(selectedCategories));
				return;
			}

			localStorage.setItem("category-option", JSON.stringify(selectedCategories));
			onFetchLatestPets(selectedCategories, 1, true);
		},
		[selectedCategories, onFetchLatestPets]
	);

	const onUpdateCategoryOption = useCallback(
		(category) => {
			if (category === "all") {
				return setSelectedCategories([]);
			}

			const newCategories = [...selectedCategories];
			const categoryIndex = newCategories.indexOf(category);
			if (categoryIndex > -1) {
				newCategories.splice(categoryIndex, 1);
			} else {
				newCategories.push(category);
			}
			setSelectedCategories(newCategories);
		},
		[selectedCategories]
	);

	useEffect(() => {
		(async () => {
			const categories = await (
				await fetch(`https://shackpets.shacknews.com/api/categories`)
			).json();
			setCategories(categories);

			const selectedCategories = localStorage.getItem("category-option") || "[]";
			setSelectedCategories(JSON.parse(selectedCategories));
		})();
	}, []);

	return (
		<>
			<button className="category-menu-btn" onClick={() => setOpen(true)}>
				<img src={SORT_ICON} alt="icon" />
				<span>Filter</span>
			</button>
			<Popup open={isOpen} className="category-menu" onClose={() => onHandleCategoryMenu(false)}>
				<div className="category-menu">
					<h1>Filter</h1>

					<p className="title">By Pet Type</p>
					<div className="category-wrapper">
						<button className="category-item" onClick={() => onUpdateCategoryOption("all")}>
							<span>all</span>
							<input
								type="radio"
								checked={!selectedCategories.length}
								onChange={() => onUpdateCategoryOption("all")}
							/>
						</button>

						{categories.map((category, index) => {
							const isSelected = selectedCategories.includes(category.id);

							return (
								<button
									key={index}
									className="category-item"
									onClick={() => onUpdateCategoryOption(category.id)}
								>
									<span>{category?.name}</span>
									<input
										type="checkbox"
										checked={isSelected}
										onChange={() => onUpdateCategoryOption(category.id)}
									/>
								</button>
							);
						})}
					</div>

					<div className="category-footer">
						<button onClick={() => onHandleCategoryMenu(false)}>
							<span>Cancel</span>
						</button>
						<button className="selected" onClick={() => onHandleCategoryMenu(true)}>
							<span>Update</span>
						</button>
					</div>
				</div>
			</Popup>
		</>
	);
}
